import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import axios from "axios";
import {
  Table,
  Button,
  Select,
  Row,
  Col,
  Input,
  DatePicker,
  Menu,
  Dropdown,
  Space,
} from "antd";
import { any } from "prop-types";
import moment from "moment";
import OpdPrint from "./printForSale";
import ReactToPrint from "react-to-print";
import HeaderBar from "../../../components/header/headerBar";

interface ParamTypes {
  searchText?: string;
}

const OPDSearch = () => {
  const { RangePicker } = DatePicker;
  // const navigate = useHistory();
  // const [route, setRoute] = useState("");
  const { searchText } = useParams<ParamTypes>();
  const history = useHistory();
  const [tableList, setTableList] = useState<any>([]);
  const [branch, setBranch] = useState<any>([]);
  const [dataSearch, setDataSearch] = useState<any>([]);
  const [isDisable, setIsDisable] = useState<any>([]);
  const [dataPrint, setDataPrint] = useState<any>([]);
  const [dataType, setDataType] = useState<any>([]);
  const [nameTitle, setNameTitle] = useState<string>("");
  const [dropdownId, setDropdownId] = useState<string>("");

  const types = [
    { value: "cn", label: "CN" },
    { value: "name", label: "NAME-SURNAME" },
    { value: "tel", label: "Tel." },
  ];
  const monthType = [
    { value: "all", label: "All" },
    { value: "select", label: "SELECT MONTH" },
  ];
  const menu = (
    <Menu
      items={[
        {
          key: "1",
          label: (
            <OpdPrint
              ComponentRef="opdPrint"
              title="Print Label OR&Anti"
              dataOpdPrint={dataPrint}
              type="OR&Anti"
            />
          ),
        },
        {
          key: "2",
          label: (
            <OpdPrint
              ComponentRef="opdPrint"
              title="Print Label For Sale"
              dataOpdPrint={dataPrint}
              type="forSale"
            />
          ),
        },
        {
          key: "3",
          label: (
            <a
              href={`/opd/printLabelDrugs/${dropdownId}`}
              style={{ textDecoration: "none", color: "#323C47" }}
            >
              Print Label ยา/แบบไม่มีชื่อลูกค้า
            </a>
          ),
        },
      ]}
    />
  );

  const columns = [
    {
      title: "",
      dataIndex: "index",
      colSpan: 1,
      key: 1,
      width: "10px",
    },
    {
      title: "รหัสลูกค้า / CN",
      dataIndex: "code",
      colSpan: 1,
      width: "150px",
      key: 2,
    },
    {
      title: () => {
        return (
          <div>
            <text>ชื่อ-นามสกุล /</text>
            <br />
            <text>Name-Surname</text>
          </div>
        );
      },
      dataIndex: "name",
      colSpan: 1,
      width: "170px",
      key: 3,
    },
    {
      title: "เบอร์โทรศัพท์ / Tel.",
      dataIndex: "tel",
      colSpan: 1,
      width: "150px",
      key: 4,
    },
    {
      title: "สาขาล่าสุด / Latest Branch",
      dataIndex: "lastedBranch",
      colSpan: 1,
      width: "200px",
      key: 5,
    },
    {
      title: () => {
        return (
          <div>
            <text>คอร์สล่าสุด(ทรีทเม้นท์) /</text>
            <br />
            <text>Latest Course(Treatment)</text>
          </div>
        );
      },
      dataIndex: "lastedCourse",
      colSpan: 1,
      width: "200px",
      key: 6,
    },
    {
      title: "วันที่ / Date",
      dataIndex: "createdAt",
      colSpan: 1,
      width: "170px",
      key: 7,
      render: (data: any) => {
        return moment(data).format("DD-MM-YYYY hh:mm A");
      },
    },
    {
      title: "Action",
      colSpan: 3,
      width: "100px",
      align: "center" as const,
      key: 10,
      render: (data: any) => (
        <div className="dropdown-custom">
          <Dropdown
            overlay={menu}
            placement="bottom"
            onVisibleChange={(e) => getDropdownData(e, data._id)}
          >
            <Icon
              icon="fluent:print-16-filled"
              width="1.2rem"
              height="1.2rem"
              style={{ color: "#5BAEA9" }}
            />
          </Dropdown>
        </div>
      ),
    },
    {
      colSpan: 0,

      align: "center" as const,
      key: 9,
      width: "100px",
      render: (data: any) => (
        <a
          // href={`/opd/list/${data._id}`}
          onClick={() => {
            history.push(`/opd/list/${data._id}`);
          }}
        >
          <Icon
            icon="akar-icons:eye"
            width="1.2rem"
            height="1.2rem"
            style={{ color: "#5BAEA9" }}
          />
        </a>
      ),
    },
    {
      colSpan: 0,
      width: "100px",
      align: "center" as const,
      key: 10,
      render: (data: any) => (
        <div className="btn-table">
          {/* {console.log("data", data?._id)} */}
          <Button
            type="primary"
            htmlType="submit"
            onClick={() => history.push(`/opd/so/${data?._id}`)}
          >
            SO
          </Button>
        </div>
      ),
    },
  ];

  const monthFormat = "YYYY-MM";

  const getDropdownData = async (check: any, dataId: any) => {
    if (check) {
      setDropdownId(dataId);
      await axios.get(`/member-opd/${dataId}`).then((res) => {
        setDataList(res?.data);
      });
    }
  };

  const setDataList = async (data: any) => {
    let prefix = "";
    let state = "";
    let city = "";
    let subCity = "";
    let postalCode = "";
    let gender = "";

    let difference = moment().diff(data?.birthDate);
    let duration = moment.duration(difference);
    let year = duration.years();
    let day = duration.days();
    let month = duration.months();

    await axios.get(`/states/${data?.address?.state}`).then((res) => {
      state = res?.data?.name;
    });
    await axios.get(`/cities/${data?.address?.city}`).then((res) => {
      city = res?.data?.name;
    });
    await axios.get(`/sub-cities/${data?.address?.subCity}`).then((res) => {
      subCity = res?.data?.name;
    });
    await axios
      .get(`/postal-codes/${data?.address?.postalCode}`)
      .then((res) => {
        postalCode = res?.data?.name;
      });

    await axios.get(`/prefixes/${data?.prefix}`).then((res) => {
      prefix = res?.data?.name;
    });
    await axios.get(`/genders/${data?.gender}`).then((res) => {
      gender = res?.data?.name;
    });

    setDataPrint({
      age: `${year} ปี ${month} เดือน ${day} วัน`,
      code: data?.code,
      name: `${prefix}${data?.firstName} ${data?.lastName}`,
      address: `${data?.address?.addressNumber} ${data?.address?.buildingName} 
                ${data?.address?.moo} ${data?.address?.soi}
                ${data?.address?.road}
                แขวน ${city} เขต ${subCity} ${state} ${postalCode}`,
    });
  };

  const getOpdList = async () => {
    let branchId = dataSearch?.branch ? dataSearch?.branch : "all";
    let startMonthData = dataSearch?.startMonth
      ? `&startMonth=${dataSearch?.startMonth}`
      : "";
    let endMonthData = dataSearch?.endMonth
      ? `&endMonth=${dataSearch?.endMonth}`
      : "";

    let searchData = dataSearch?.search
      ? `&${dataType?.typeSearch ? dataType?.typeSearch : "search"}=${
          dataSearch?.search
        }`
      : `&search=${searchText}`
      ? `&search=${searchText}`
      : "";

    await axios
      .get(
        `/member-opd?page=1&branch=${branchId}${startMonthData}${endMonthData}${searchData}`
      )
      .then((res) => {
        let data = res?.data?.data;
        console.log("data", data);

        data = data.map((item: any, index: any) => ({
          ...item,
          index: index + 1,
        }));
        console.log("data =>>", data);

        setTableList(data);
      });
  };

  const getBranches = async () => {
    await axios.get(`/branches`).then((res) => {
      let data = [{ _id: "all", name: "All" }, ...res?.data?.data];

      const branch = [];

      for (let i = 0; i < data?.length; i++) {
        branch.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }
      setBranch(branch);
    });
  };

  const selectedItems = async (item: any) => {
    if (item === "select") {
      setIsDisable({ ...isDisable, isMonth: true });
    } else {
      setIsDisable({ ...isDisable, isMonth: false });
      setDataSearch({ ...dataSearch, startMonth: "", endMonth: "" });
    }
  };

  const onChangePicker = async (dates: any, dateStrings: any) => {
    if (dates) {
      setDataSearch({
        ...dataSearch,
        startMonth: moment(dates[0]).format(monthFormat),
        endMonth: moment(dates[1]).format(monthFormat),
      });
    } else {
      setDataSearch({ ...dataSearch, startMonth: "", endMonth: "" });
    }
  };

  useEffect(() => {
    setDataSearch({ ...dataSearch, search: searchText });
    getOpdList();
    getBranches();
  }, []);

  useEffect(() => {
    console.log(dataSearch);
    getOpdList();
  }, [dataSearch]);
  useEffect(() => {
    console.log(dataType);
  }, [dataType]);

  return (
    <div className="opd-table-list">
      <HeaderBar title="OPD" onClick={() => history.push(`/opd/`)} />
      <div style={{ padding: "0px 40px", margin: "10px 40px" }}>
        <div className="input-search">
          <Select
            className="select-search"
            // bordered={false}
            style={{ borderBottom: "red" }}
            placeholder="Search for Name"
            suffixIcon={
              <Icon
                icon="ant-design:caret-down-filled"
                style={{ color: "#AEAEAE" }}
              />
            }
            onChange={(e) => {
              // setDataSearch({ ...dataSearch, typeSearch: e });
              setDataType({ typeSearch: e });
              setIsDisable({ ...isDisable, isSearch: true });
            }}
            options={types}
          />
          <Input.Search
            bordered={false}
            disabled={isDisable?.isSearch ? false : true}
            onSearch={(e) => {
              setDataSearch({ ...dataSearch, search: e });
            }}
          />
        </div>

        <div style={{ marginTop: "20px" }}>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <div className="search-data-list">
                <div>
                  <p>BRANCH: </p>
                </div>
                <div className="select-data">
                  <Select
                    bordered={false}
                    defaultValue="all"
                    suffixIcon={
                      <Icon
                        icon="ant-design:caret-down-filled"
                        style={{ color: "#AEAEAE" }}
                      />
                    }
                    onChange={(e) => {
                      setDataSearch({ ...dataSearch, branch: e });
                    }}
                  >
                    {branch}
                  </Select>
                </div>
              </div>
            </Col>
            <Col span={6}>
              <div className="search-data-list">
                <p>MONTH:</p>
                <Select
                  bordered={false}
                  defaultValue="all"
                  suffixIcon={
                    <Icon
                      icon="ant-design:caret-down-filled"
                      style={{ color: "#AEAEAE" }}
                    />
                  }
                  onChange={selectedItems}
                  options={monthType}
                />
              </div>
            </Col>
            {isDisable?.isMonth && (
              <>
                <Col span={8}>
                  <div className="search-data-list">
                    <RangePicker
                      ranges={{
                        Today: [moment(), moment()],
                        "This Month": [
                          moment().startOf("month"),
                          moment().endOf("month"),
                        ],
                      }}
                      bordered={false}
                      picker="month"
                      format={monthFormat}
                      onChange={onChangePicker}
                    />
                  </div>
                </Col>
              </>
            )}
          </Row>
          <div style={{ marginTop: "20px" }} className="table-data">
            <Table
              columns={columns}
              dataSource={tableList}
              bordered
              scroll={{ x: 1000 }}
              rowKey="_id"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default OPDSearch;
